$ = jQuery;
$(document).ready(function () {
   
    //IMAGE MAP RESIZE SCRIPT START
    $('.global-action-map map').imageMapResize();
    //IMAGE MAP RESIZE SCRIPT END
    //BACK TO TOP BUTTON START
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('.back-to-top').fadeIn('slow');
        } else {
            $('.back-to-top').fadeOut('slow');
        }
    });
    $('.back-to-top').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 1500);
        return false;
    });
    //BACK TO TOP BUTTON END
    $('.news-stroy-event-wrap .region-single-article').addClass("row").find('.block-views').addClass("col-lg-6 col-md-6").first().removeClass("col-lg-6 col-md-6").addClass("col-lg-12 col-md-12");

    $(".node-ms-upload-reports-form .ui-accordion .ui-accordion-header").closest(".field-group-fieldset").addClass("accordion-fieldset");

    $(".page-node-type-ms-upload-reports").find('.form-item-field-documents-and-reports-type-353 label').append('<i title="Upload previous statements shared during major events and conferences" class="fa fa-info-circle margin-left-5" aria-hidden="true"></i>');

    //knowldge at a glance search
    $('.knowledge-search').click(function () {
        var keyword = $("#knowledge-val").val();
        var url = window.location.hostname;
        if (url.indexOf('?') > -1) {
            url = '/search/node/&keys=' + keyword + '&f[]=type:knowledge';
        } else {
            url = '/search/node/?keys=' + keyword + '&f[]=type:knowledge';
        }
        window.location = encodeURI(url);
    });
    $(".input-group-search-btn").on("click", function () {
        $('#input-group-form')[0].reset();
    });
    var communityurl = $(".community_url").val();
    $(".community-link").attr("href", communityurl);
    $(".unsystem-table tbody tr").each(function () {
        $(this).find('td a').parent().css('word-break', 'break-all');
    });
    
    if($("#edit-field-not-applicable-0").is(':checked')){
         $('div.form-item-field-are-you-focal-point').attr('disabled', true);
         $('#edit-field-organisation-target-id').val('');
    }else{
        $('.form-item-field-are-you-focal-point').removeAttr('disabled', true);
    }
 
    
});

 

function getParams(url) {

    var queryString = url.substring(url.indexOf('?') + 1);
    var paramsArr = queryString.split('&');
    var params = {};

    for (var i = 0, len = paramsArr.length; i < len; i++) {
        var keyValuePair = paramsArr[i].split('=');
        params[keyValuePair[0]] = keyValuePair[1];
    }

    return params;
}

